// Lodash.
window._ = require('lodash');

// Axios.
// TODO: Remove once everything is using the Http service.
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.timeout = 180000;
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// JQuery.
window.$ = require("jquery");
require('./vendor/jquery-ui.min.js');

// DateTime Pickers.
// TODO: Remove once everything is using "UiDatePicker".
import flatpickr from "flatpickr";
window.$(document).ready(function () {
    flatpickr(".date-picker", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d"
    });
    flatpickr(".date-picker-multiple", {
        altInput: true,
        mode: "multiple",
        altFormat: "F j, Y",
        dateFormat: "Y-m-d"
    });
});
